import { render, staticRenderFns } from "./ComputerApplications.vue?vue&type=template&id=fa2c3e44&"
import script from "./ComputerApplications.vue?vue&type=script&lang=js&"
export * from "./ComputerApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports